export default "__VITE_ASSET__$Ce4CENk__"